export default function Services() {
  const services = [
    {
      icon: 'ri-bowl-line',
      title: 'Bathroom Safety',
      description: 'Walk-in tubs, grab bars, non-slip flooring, and accessible showers designed for maximum safety and independence. Our bathroom modifications reduce fall risks while maintaining comfort and dignity.'
    },
    {
      icon: 'ri-stairs-line',
      title: 'Mobility Access',
      description: 'Professional installation of stair lifts, wheelchair ramps, and platform lifts. We ensure smooth transitions between levels, making every area of your home accessible and safe for daily living.'
    },
    {
      icon: 'ri-door-open-line',
      title: 'Doorway Widening',
      description: 'Expert doorway modifications and threshold removal to accommodate wheelchairs and walkers. We create seamless pathways throughout your home while preserving structural integrity and aesthetics.'
    }
  ];

  return (
    <section id="services" className="bg-[#F8F7F5] py-12 sm:py-16 md:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-start gap-6 lg:gap-8 mb-12 lg:mb-16">
          <div className="w-full lg:w-auto">
            <div className="text-gray-500 text-xs sm:text-sm font-medium tracking-wider mb-3">OUR EXPERTISE</div>
            <h2 className="leading-tight">
              <div className="text-gray-400 text-3xl sm:text-4xl md:text-5xl font-light italic">Comprehensive</div>
              <div className="text-[#1A2B4A] text-3xl sm:text-4xl md:text-5xl font-extrabold mt-2">Safety Solutions</div>
            </h2>
          </div>
          <div className="w-full lg:max-w-xl">
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
              Expert home accessibility and structural safety modifications for seniors. From professional grab bar installation to full-home audits, we reinforce your independence.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-sm hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6 sm:mb-8">
                <i className={`${service.icon} text-[#1A2B4A] text-4xl sm:text-5xl`}></i>
              </div>
              <h3 className="text-[#1A2B4A] text-xl sm:text-2xl font-bold mb-4 sm:mb-5">{service.title}</h3>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
